<h1>Suit piercing calculator</h1>

<div class="result-wrapper">
  <div class="side-panel-container">
    <div class="form-container">
      <h2>Data:</h2>
      <div class="input-container">
        <p class="input-label">Simulate X times</p>
        <input
          class="data-input"
          type="number"
          [min]="0"
          [(ngModel)]="simulationCount"
        />
      </div>
      <div class="input-container">
        <p class="input-label">FWC</p>
        <mat-slide-toggle
          class="checkbox-input"
          [(ngModel)]="priceProvider.isFwc"
        />
      </div>
      <div class="input-container">
        <p class="input-label">Pd10</p>
        <mat-slide-toggle
          class="checkbox-input"
          [(ngModel)]="isPd10"
        />
      </div>
      <div class="input-container">
        <p class="input-label">Piercing event</p>
        <mat-slide-toggle
          class="checkbox-input"
          [(ngModel)]="isPiercingEvent"
        />
      </div>
      <div class="input-container">
        <p class="input-label">Upgrade bonus %</p>
        <input
          class="data-input"
          type="number"
          [min]="0"
          [max]="9999"
          [(ngModel)]="customUpgradeBonus"
        />
      </div>
      <div class="input-container">
        <p class="input-label">Current piercing level</p>
        <input
          class="data-input"
          type="number"
          [min]="0"
          [max]="3"
          [(ngModel)]="currentPierce"
        />
      </div>
      <div class="input-container">
        <p class="input-label">Target piercing level</p>
        <input
          class="data-input"
          type="number"
          [min]="1"
          [max]="4"
          [(ngModel)]="targetPierce"
        />
      </div>
      <div class="input-container">
        <p class="input-label">Current attempts</p>
        <input
          class="data-input"
          type="number"
          [min]="1"
          [max]="4"
          [(ngModel)]="currentAttemptsIn"
        />
      </div>
      <div class="input-container">
        <p class="input-label">gPro cost</p>
        <input
          class="data-input"
          type="number"
          [min]="0"
          [(ngModel)]="priceProvider.gProPrice"
        />
      </div>
      <div class="input-container">
        <p class="input-label">pd8 cost</p>
        <input
          class="data-input"
          type="number"
          [min]="0"
          [(ngModel)]="priceProvider.pd8Price"
        />
      </div>
      <div class="button-container">
        <button (click)="SimulateUpgrading()">Calculate</button>
      </div>
    </div>
    <div class="result-container">
      <h2>Results:</h2>
      <div class="results">
        <div class="result-row">
          <p class="bold">Total penya cost:&nbsp;</p>
          <p>{{ GetTotalPenyaCost() / simulationCount | number : "1.0-1" }}</p>
        </div>
        <br />
        <div class="result-row">
          <p class="bold">Total gPro cost:&nbsp;</p>
          <p>
            {{
              (GetGprosUsed() * priceProvider.gProPrice) /
                simulationCount | number : "1.0-1"
            }}
          </p>
        </div>
        <div class="result-row">
          <p class="bold">Total gPro's used:&nbsp;</p>
          <p>{{ GetGprosUsed() / simulationCount | number : "1.0-1" }}</p>
        </div>
        <br />
        <div class="result-row">
          <p class="bold">Total pd8 cost:&nbsp;</p>
          <p>{{ GetPd8Used() * priceProvider.pd8Price / simulationCount | number : "1.0-1" }}</p>
        </div>
        <div class="result-row">
          <p class="bold">Total pd8 used:&nbsp;</p>
          <p>{{ GetPd8Used() / simulationCount | number : "1.0-1" }}</p>
        </div>
      </div>
    </div>
  </div>
  <div class="upgrade-chart">
    <canvas id="upgrade-data-chart"></canvas>
  </div>
</div>
